module.exports = __webpack_public_path__ + "static/media/kitty2.6d46a996.gif";